var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',{staticClass:"justify-space-between"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('sheetClose')}}},[_c('Close')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }